<div #spotifyContainer class="spotify-container">
    <!-- <iframe
      style="border-radius: 12px;"
      [src]="getSafeUrl(spotifyId)"
      width="100%"
      height="352"
      frameborder="0"
      allowfullscreen=""
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy">
    </iframe> -->
  </div>